import { Button, Card, CardContent, DataTable, PageHeader, StatusChip } from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { usePaymentAction, usePayments } from "../../features/ops/queries.ts";
import type { PaymentRecord } from "../../features/ops/types.ts";
import { formatMoney } from "../../lib/format.ts";

export const Route = createFileRoute("/_app/cashier")({ component: CashierScreen });

function CashierScreen() {
  const { data: payments = [] } = usePayments();
  const action = usePaymentAction();
  const [reason, setReason] = useState("Customer requested refund review");
  return (
    <div className="space-y-6">
      <PageHeader
        title="Cashier / แคชเชียร์"
        subtitle="Table bill summary, gift-paid labels, payment capture, and refund requests."
      />
      <Card>
        <CardContent className="space-y-4 p-5">
          <label className="block text-sm">
            Refund reason
            <input
              className="mt-2 flex h-11 w-full rounded-md border border-input bg-transparent px-3 text-sm"
              value={reason}
              onChange={(event) => setReason(event.target.value)}
            />
          </label>
          <DataTable<PaymentRecord>
            rows={payments}
            getRowKey={(row) => row.id}
            caption="Payments"
            columns={[
              { key: "table", header: "Table", cell: (row) => row.tableLabel },
              { key: "amount", header: "Amount", cell: (row) => formatMoney(row.amountMinor) },
              {
                key: "gift",
                header: "Gift items",
                cell: (row) =>
                  row.giftPaidMinor > 0
                    ? `sender-paid / recipient-received ${formatMoney(row.giftPaidMinor)}`
                    : "none",
              },
              {
                key: "status",
                header: "Status",
                cell: (row) => (
                  <StatusChip
                    tone={
                      row.status === "captured"
                        ? "success"
                        : row.status.includes("refund")
                          ? "warning"
                          : row.status === "failed"
                            ? "danger"
                            : "info"
                    }
                  >
                    {row.status}
                  </StatusChip>
                ),
              },
              {
                key: "actions",
                header: "Actions",
                cell: (row) => (
                  <div className="flex gap-2">
                    <Button
                      size="sm"
                      onClick={() =>
                        action.mutate({ paymentId: row.id, action: "capture", method: "cash" })
                      }
                    >
                      Paid cash
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() =>
                        action.mutate({ paymentId: row.id, action: "capture", method: "promptpay" })
                      }
                    >
                      PromptPay
                    </Button>
                    <Button
                      size="sm"
                      variant="destructive"
                      onClick={() => action.mutate({ paymentId: row.id, action: "refund", reason })}
                    >
                      Refund
                    </Button>
                  </div>
                ),
              },
            ]}
          />
        </CardContent>
      </Card>
    </div>
  );
}
